import { SetStateAction } from "react";
import { docIdCodes, transferDocs } from "../../../data/docCodes";
import { stdObject } from "../../../data/types/stdObject";
import { updateDocTransferValue } from "../functions/updateDocTransferValue";
import { toPrice } from "../../../utils/toPrice";
import { colors } from "../../../data/colors";
import { createDocTransfer } from "../functions/createDocTransfer";

export const transferModal = ({
  t,
  items,
  staffList,
  documentAction,
  docValues,
  packTransfer,
  userAccess,
  modalData,
  setMsg,
  setModalData,
  closeMsg,
  logoutAction,
}: stdObject) => {
  return {
    title:
      t(`c.${modalData.type === "PRE" ? "PREP" : modalData.type}`) +
      ` ${modalData.serie}-${modalData.code}`,
    mainColor: modalData.mainColor,
    blocked: true,
    tabs:
      "type" in docValues && docValues.type in transferDocs
        ? transferDocs[docValues.type as keyof typeof transferDocs]
            .filter((e: string) => {
              const idCode = docIdCodes[e];
              return idCode ? userAccess[idCode[0]][idCode] : false;
            })
            .map((e: string, index: number) => {
              return {
                code: index,
                label: e === "PRE" ? t(`c.PREP`) : t(`c.${e}`),
              };
            })
        : [],
    tabAction: (index: number) =>
      setModalData({
        ...modalData,
        target:
          transferDocs[docValues.type as keyof typeof transferDocs][index],
      }),
    table:
      "items" in modalData
        ? modalData.items.map((e: stdObject, index: number) => {
            const avaliableQty =
              e[`CAN${docValues.itemType}`] - e.transferTotal;
            return {
              data: [
                {
                  value: e.active ? "1" : "0",
                  type: "checkbox",
                  active: e.maxQuantity,
                  onChange: (o: {
                    target: { value: SetStateAction<string> };
                  }) =>
                    updateDocTransferValue(
                      index,
                      "active",
                      !(o.target.value === "1"),
                      packTransfer,
                    ),
                },
                e[`ART${docValues.itemType}`],
                e[`NOM${docValues.itemType}`],
                avaliableQty > 0 &&
                avaliableQty === e[`CAN${docValues.itemType}`]
                  ? avaliableQty
                  : avaliableQty + " / " + e[`CAN${docValues.itemType}`],
                toPrice(e[`PRE${docValues.itemType}`]),
                {
                  value: e.quantity,
                  type: "number",
                  style: { width: 70 },
                  active: e.active,
                  innerStyle: { textAlign: "right" },
                  onChange: (o: {
                    target: { value: SetStateAction<string> };
                  }) =>
                    updateDocTransferValue(
                      index,
                      "quantity",
                      o.target.value as string,
                      packTransfer,
                    ),
                },
                {
                  text: toPrice(e[`PRE${docValues.itemType}`] * e.quantity),
                  style: { textAlign: "right" },
                },
              ],
              style: {
                backgroundColor:
                  avaliableQty && e.active ? colors.white : colors.lightGrey,
              },
            };
          })
        : [],
    inputs: ["NET", "IMP", "TOT", "OBS"].map((e: string) => {
      return {
        label: t(`c.${e}`),
        value: modalData[e],
        tabId: -1,
        type: e === "OBS" ? "text" : "info",
        onChange:
          e === "OBS"
            ? (v: { target: { value: SetStateAction<string> } }) =>
                updateDocTransferValue(
                  -1,
                  "OBS",
                  v.target.value as string,
                  packTransfer,
                )
            : null,
      };
    }),
    previous: modalData.previous,
    next: modalData.next,
    buttons: [
      {
        label: t("p.create"),
        onClick: modalData.open
          ? () =>
              createDocTransfer({
                docValues,
                modalData,
                setMsg,
                closeMsg,
                items,
                staffList,
                logoutAction,
              })
          : () => {},
        color: modalData.open ? colors.green : colors.darkGrey,
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          documentAction.current = {};
          closeMsg();
        },
        color: colors.darkGrey,
      },
    ],
  };
};
